<ul class="breadcrumb">
  <li class="breadcrumb-item wizard">Pre-Log Entry</li>
  <li class="breadcrumb-item wizard"><i class="fa fa-chevron-right"></i>Review Entry</li>
  <li class="breadcrumb-item wizard inactive"><i class="fa fa-chevron-right"></i>Ready to Send Sample</li>
  <li class="ms-auto">@if (externalLinks) {
    <a [href]="externalLinks.dataBankResourcesUrl" target="_blank"><i class="fa fa-external-link" style="width: 20px;"></i>DNA Data Bank Resources</a>
  }</li>
</ul>
<div class="text-center">
  <h1>Review Entry</h1>
  <p style="margin-bottom: 5px;">Please review your entry and confirm that it is correct before continuing.</p>
  <p>Clicking Submit is like dropping the form in the mail... you will not be able to make changes after you Submit.</p>
</div>
@if (errorMessage) {
  <div class="col-12 col-lg-6 offset-lg-3 alert alert-danger">{{errorMessage}}</div>
}
<app-pre-log-display [preLog]="preLog"></app-pre-log-display>
<div class="row">
  <div class="col-12 text-end">
    @if (working) {
      <i class="me-2 fa fa-spinner fa-spin"></i>
    }
    <button type="button" class="btn btn-secondary me-3" (click)="backToEntry()"><i class="fa fa-chevron-left"></i> Edit</button>
    <button type="button" class="btn btn-primary" (click)="saveAndContinue()">Submit <i class="fa fa-chevron-right"></i></button>
  </div>
</div>
